import axios from 'axios/index'
import reportData from '../../components/json/reports.json'

const namespaced = true

const state = {
  reportMenuItems: [],
  reportItemLink: null,
  controls: null,
  reportFields: [],
  reportItems: [],
  busyState: false,
  cancelToken: null,
  source: null,
  reportData: null,
  dealers: null
}
const actions = {
  getReportParams ({ state, commit }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('setReportData', reportData[state.reportItemLink])
        resolve('result')
      }, 1000)
    })
  },
  getReportData ({ rootState, commit }, data) {
    commit('setSourceToken')
    commit('setBusyState', true)
    const params = new URLSearchParams(data).toString()
    const url = '/api/private/v3.0/piportals/' + rootState.authorization.userInfo.piportals[0].alias + '/reports/' + state.reportItemLink + '/?'
    return axios({
      method: 'GET',
      url: url + params,
      cancelToken: state.source.token
    })
      .then(response => {
        console.log(response)
        commit('setReportItems', response.data)
        commit('setBusyState', false)
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          commit('setBusyState', false)
          commit('unsetSourceToken')
          console.log('Request canceled: ', error.message)
        } else {
          console.log(error)
        }
      })
  },
  getActiveUsersReportData ({ commit }, data) {
    return new Promise((resolve, reject) => {
      const url = `/api/private/v3.0/billing/months/${data.date.dateStart}/dealers/${data.org_id}/reports/active-users/`
      axios.get(url, { params: { month_end: data.date.dateEnd, piportal_alias: data.piportal_alias, dealer_id: data.dealer_id, client_id: data.client_id } })
        .then(response => response.data)
        .then((res) => {
          commit('setReportItems', { data: res })
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getReportExcelData ({ rootState, commit }, data) {
    commit('setBusyState', true)
    const params = new URLSearchParams(data).toString()
    const url = '/api/private/v3.0/piportals/' + rootState.authorization.userInfo.piportals[0].alias + '/reports/' + state.reportItemLink + '/xlsx/?'
    return axios({
      method: 'POST',
      url: url + params,
      responseType: 'blob'
    })
      .then(response => {
        console.log(response)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'report.xls')
        document.body.appendChild(link)
        link.click()
        commit('setBusyState', false)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getDealers ({ commit }, data) {
    commit('setBusyState', true)
    return axios.get('/api/private/v3.0/dealers/filter?server_alias=' + data)
      .then(response => {
        commit('setDealers', response.data)
        commit('setBusyState', false)
      })
      .catch(error => {
        console.log(error)
        commit('setBusyState', false)
      })
  },
  loadActiveUsersReportDataXlsx ({ commit, rootState }, data) {
    const payload = {
      month_end: data.date.dateEnd,
      piportal_alias: data.piportal_alias,
      dealer_id: data.dealer_id,
      client_id: data.client_id
    }
    return axios({
      method: 'POST',
      responseType: 'blob',
      url: `/api/private/v3.0/billing/months/${data.date.dateStart}/dealers/${rootState.authorization.userInfo.company.org_id}/reports/active-users/xlsx/`,
      data: payload
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Отчет по учетным записям_${data.date.dateString}.xlsx`)
        document.body.appendChild(link)
        link.click()
        commit('setVisible', false)
      })
      .catch(error => {
        alert(error.status + ' ' + error.statusText)
        commit('setVisible', false)
      })
  }
}
const mutations = {
  changeReportItem (state, data) {
    state.reportItemLink = data
  },
  setReportData (state, data) {
    for (const key in data.fields) {
      const fieldItem =
        {
          key: key,
          label: data.fields[key]
        }
      state.reportFields.push(fieldItem)
    }
    data.controls.forEach((elm) => {
      elm.values = {}
      elm.params.forEach(param => {
        elm.values[param] = null
      })
    })
    state.controls = data.controls
  },
  setReportItems (state, data) {
    state.reportItems = data.data
  },
  setReportItemsToZero (state) {
    state.reportItems = []
    state.reportFields = []
  },
  setReportFieldsToZero (state) {
    state.reportFields = null
  },
  setBusyState (state, data) {
    state.busyState = data
  },
  setSourceToken (state) {
    state.cancelToken = axios.CancelToken
    state.source = state.cancelToken.source()
  },
  cancelSourceToken (state, value) {
    if (state.source !== null) {
      state.source.cancel(value.message)
    }
  },
  unsetSourceToken (state) {
    state.cancelToken = null
    state.source = null
  },
  setDealers (state, data) {
    if (data) {
      state.dealers = data
    } else {
      state.dealers = []
    }
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
